import { render, staticRenderFns } from "./teachingCenter.vue?vue&type=template&id=5e99543d&scoped=true"
import script from "./teachingCenter.vue?vue&type=script&lang=js"
export * from "./teachingCenter.vue?vue&type=script&lang=js"
import style0 from "./teachingCenter.vue?vue&type=style&index=0&id=5e99543d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99543d",
  null
  
)

export default component.exports